import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e8df7de"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "listWrapper" };
const _hoisted_2 = { class: "item" };
const _hoisted_3 = { class: "imgBox" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "num" };
const _hoisted_6 = { class: "info" };
const _hoisted_7 = { class: "goodName text-ell2" };
const _hoisted_8 = { class: "desc text-overflow" };
const _hoisted_9 = { class: "expert" };
const _hoisted_10 = { class: "price" };
const _hoisted_11 = ["onClick"];
import Empty from '@/components/common/Empty.vue';
import { watch, ref } from 'vue';
import { createAlbumOrder } from '@/api/video';
import { getUrlParam, getUserId, userLogin } from '@/widget/index';
import { jumpModuleApp, appPort } from '@/widget/index';
import { useRouter } from 'vue-router';
import { createMeetingOrder } from '@/api/meeting';
import { createVipOrder } from '@/api/user';
import { createGoodOrder } from '@/api/mall';
import { find } from 'lodash-es';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: {
            default: [],
            type: Array
        }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        // 购物车商品列表中商品ID
        const productId = ref(Number(getUrlParam('productId')));
        let liveId = getUrlParam('liveId') || '';
        watch(() => props.list, () => {
            if (productId.value) {
                let item = find(props.list, { cartProductId: productId.value });
                if (item) {
                    createOrder(item);
                }
                else {
                    productId.value = 0;
                }
            }
        });
        let userId = getUserId();
        const createOrder = (item) => {
            if (!userId) {
                userLogin();
                return;
            }
            // "productType": "vip", //类型
            // album_vip:课程商品-会员课
            // album_case:课程商品-案例课
            // meeting_online:课程商品-线上共学营
            // meeting_omo:课程商品-OMO训练营
            // vip:会员商品
            // mall:商城商品
            let type = item.productType;
            let id = item.productId;
            let query = { livePage: 1, liveId: liveId };
            if (productId.value) {
                query.productId = productId.value;
            }
            if (type == 'album_case' || type == 'album_vip') {
                // 专辑购买
                createAlbumOrder({ userId, videoIds: '', albumId: id }).then((res) => {
                    if (res.code == 200) {
                        router.push({
                            path: `/order/album/${res.data}`,
                            query
                        });
                    }
                });
            }
            else if (type == 'meeting_omo' || type == 'meeting_online') {
                // omo 共学营
                createMeetingOrder({
                    userId: userId,
                    meetingId: id
                }, {
                    sourceId: String(getUrlParam('sourceId') || '0')
                }).then(res => {
                    if (res.code === 200) {
                        router.push({
                            name: 'orderDetail',
                            params: {
                                module: 'meeting',
                                orderId: res.data
                            },
                            query
                        });
                    }
                });
            }
            else if (type == 'mall') {
                // 商品订单
                createGoodOrder({
                    userId,
                    products: [{ productId: id, num: 1, specificationId: 0 }]
                }).then((res) => {
                    if (res.code == 200) {
                        if (appPort()) {
                            jumpModuleApp({
                                typeId: 'product_order_detail',
                                orderId: res.data
                            });
                            productId.value = 0;
                        }
                    }
                });
            }
            else if (type == 'vip') {
                // 会员订单
                createVipOrder({ vipId: id, userId }).then((res) => {
                    if (res.code == 200) {
                        router.push({
                            name: 'orderDetail',
                            params: {
                                module: 'vip',
                                orderId: res.data.orderId
                            },
                            query
                        });
                    }
                });
            }
        };
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.list.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.list, (item, ind) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("img", {
                                    src: item.websiteImage,
                                    alt: ""
                                }, null, 8, _hoisted_4),
                                _createElementVNode("div", _hoisted_5, _toDisplayString(ind + 1), 1),
                                _withDirectives(_createElementVNode("div", { class: "pop" }, _toDisplayString(item.popScreenText), 513), [
                                    [_vShow, item.isPopScreen]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(item.productName), 1),
                                _withDirectives(_createElementVNode("div", _hoisted_8, [
                                    (item.expertList.length)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.expertList, (e) => {
                                            return (_openBlock(), _createElementBlock("span", null, [
                                                _createElementVNode("span", _hoisted_9, _toDisplayString(e.expertName), 1),
                                                _createElementVNode("span", null, _toDisplayString(e.expertHospitalName), 1)
                                            ]));
                                        }), 256))
                                        : _withDirectives((_openBlock(), _createElementBlock("span", { key: 1 }, _toDisplayString(item.tips), 513)), [
                                            [_vShow, item.tips]
                                        ])
                                ], 512), [
                                    [_vShow, item.tips || item.expertList.length]
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("ins", null, _toDisplayString(item.productPrice), 1)
                                    ]),
                                    _createElementVNode("div", {
                                        class: "btn",
                                        onClick: _withModifiers(($event) => (createOrder(item)), ["stop"])
                                    }, _toDisplayString(item.btnText), 9, _hoisted_11)
                                ])
                            ])
                        ]));
                    }), 256))
                    : (_openBlock(), _createBlock(Empty, {
                        key: 1,
                        text: '课程内容筹备中，敬请期待'
                    }))
            ], 512)), [
                [_vShow, !productId.value]
            ]);
        };
    }
});
